/**
 * Lo que «Programaciones» (features/scheduler) exige de la sesión de Sirius para entrar: el módulo de organización
 * `scheduler` (`public.org_modules`, en el JWT como `orgModules[].key`) y alguno de los dos accesos del módulo
 * (`public.access.name`, en el JWT como `access[]`): `scheduler_admin` (crear, editar, pausar, ejecutar, borrar y
 * ajustes) o `scheduler_read` (solo lectura). Lo usan el menú (`PagesComponent.canAccessScheduler`) y el guard de la
 * ruta (`SchedulerModuleGuard`); dentro de la feature `SchedulerSessionService` deriva de la misma lista qué acciones
 * se habilitan. La autoridad sigue siendo la API (`@AccessRequired` en `apps/api/src/modules/scheduler`).
 */
export const SCHEDULER_MODULE_KEY = 'scheduler';

export const SCHEDULER_ADMIN_ACCESS = 'scheduler_admin';
export const SCHEDULER_READ_ACCESS = 'scheduler_read';

export const SCHEDULER_ACCESSES = [SCHEDULER_ADMIN_ACCESS, SCHEDULER_READ_ACCESS] as const;

export type SchedulerAccess = (typeof SCHEDULER_ACCESSES)[number];
